<div
  class="gap-[var(--p-spacing-6)] flex items-start pt-[var(--p-spacing-4)]"
  [class.sidebar-mobile-visible]="showMobileSidebar()">
  <main class="sidebar-layout-main w-full">
    <div class="sidebar-layout-content">
      <ng-content select="[content]"></ng-content>
    </div>
  </main>

  <aside class="sidebar-layout-sidebar">
    <p-card>
      <ng-content select="[sidebar]"></ng-content>
    </p-card>
  </aside>
</div>
